import React, { useState } from 'react';
import { flowRight as compose } from 'lodash';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';

// Component
import AdminReviewsManagement from '../../../components/siteadmin/AdminReviewsManagement/AdminReviewsManagement';

import s from './AdminReviews.css';

const AdminReviews = (props) => {

    const [state, setState] = useState({
        currentPage: 1,
        searchList: ''
    });
    const setStateVariable = (variables) => {
        setState(variables)
    }

    const { title } = props;
    const { currentPage, searchList, userType } = state;
    return <AdminReviewsManagement
        title={title}
        currentPage={currentPage}
        searchList={searchList}
        userType={userType}
        setStateVariable={setStateVariable} />;
}

export default compose(
    withStyles(s),
)(AdminReviews);